import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Data, Params } from '@angular/router';
import { LegionellaVisitOverview } from 'src/app/models/legionella.model';

@Component({
  selector: 'app-legionella-visits',
  templateUrl: './legionella-visits.component.html',
  styleUrls: ['./legionella-visits.component.scss']
})
export class LegionellaVisitsComponent implements OnInit {

  sites: string[];
  machines: string[];
  siteFilter: string = 'All';
  machineFilter: string = 'All';
  poFilter: string = '';
  visits: LegionellaVisitOverview[];

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.route.data.subscribe((data: Data) => {
      this.sites = data.sites.sites;
      this.machines = data.sites.machines;
      this.visits = data.visits;
    });

    this.route.params.subscribe((params: Params) => {

      if (params['type']) {
        if (params['type'] == 'machine') {
          this.machineFilter = params['filter'];
          this.siteFilter = 'All';
        } else if (params['type'] == 'site') {
          this.siteFilter = params['filter'];
          this.machineFilter = 'All';
        } else {
          this.siteFilter = 'All';
          this.machineFilter = 'All';
        }
      }

    });

  }

  onFilterChange(type: string, filter: string) {
    if (filter == 'All') {
      this.router.navigate(['support-service', 'legionella-tests']);
    } else {
      this.router.navigate(['support-service', 'legionella-tests', type, filter]);
    }
  }


}
